import { Box, Fade, Modal } from "@mui/material";
import React from "react";

// assets
import nbx_logo from "../images/logo-icon.png";

const styleFlexCenter = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  flexWrap: "wrap",
  flexDirection: "column",
};

const ImgLoader = () => {
  return (
    <div style={styleFlexCenter}>
      <img
        className="spin"
        src={nbx_logo}
        alt="icono cargando"
        style={{
          width: "15vw",
          height: "auto",
          maxWidth: "80px",
          minWidth: "40px",
        }}
      />
    </div>
  );
};

const Loader = ({ open = false, content = null, fullView = true }) => {
  const styleContentLoader = () => {
    let styles = {};
    // obtenemos el header
    const elementHeader = document.querySelector("#root .row-header");
    let heightHeader = 0;

    if (elementHeader) { // si el header fue encontrado, obtenemos su altura
      heightHeader = elementHeader.offsetHeight;
    }

    if (fullView || !content) {
      styles.height = "100%";
      styles.width = "100%";
      styles.maxWidth = "100%";
      styles.background = "rgba(255, 255, 255, .9)"; 
      heightHeader = 0;
    } else {
      styles.borderRadius = "15px";
      styles.minHeight = "100px";
      styles.width = "80%";
      styles.maxWidth = "800px";
      styles.background = "#ffffff";
      styles.padding = "1rem";
    }
    return {
      boxShadow: 5,
      marginTop: heightHeader + "px",
      gap: "1rem",
      ...styleFlexCenter,
      ...styles,
    };
  };

  return (
    <Modal
      open={open}
      aria-labelledby="loader"
      aria-describedby="Procesando"
      style={{
        ...styleFlexCenter,
      }}
      disableEscapeKeyDown={true}
      disableAutoFocus={true}
    >
      <Fade in={open}>
        <Box sx={styleContentLoader()}>
          <ImgLoader />
          {content}
        </Box>
      </Fade>
    </Modal>
  );
};

export default Loader;
